import apiClient from '@/services/AccountClient'

export default {
  getRates () {
    return apiClient.sendRequest(
      'GET',
      'api/admin/v1/currencies/rates'
    )
  },

  updateRate (rate) {
    return apiClient.sendRequest(
      'PUT',
      'api/admin/v1/currencies/rates',
      rate
    )
  }
}
